module.exports = __webpack_public_path__ + "img/college_icon1.44ed465.png";